import React from 'react';
import { TASK_PRIORITY_COLORS, TASK_PRIORITY_LABELS } from '../../constants/taskStatuses';

export default function TaskPriorityBadge({ priority, size, className = '', ...rest }) {
  const colorClasses = TASK_PRIORITY_COLORS[priority] || 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300';
  const label = TASK_PRIORITY_LABELS[priority] || priority || '-';
  const sizeClasses = size === 'md' ? 'px-3 py-1 text-sm' : 'px-2 py-0.5 text-xs';

  return (
    <span className={`inline-block rounded-full font-semibold ${sizeClasses} ${colorClasses} ${className}`.trim()} {...rest}>
      {label}
    </span>
  );
}
